import * as _ from 'underscore';
import { util } from '../../util';
import { Inject, Injectable } from '@angular/core';
import { IExtendedDocument, IExtendedWindow, IRecord } from '../../../../type_definitions/datatypes';
import { HttpErrorResponse } from '@angular/common/http';
import { HttpDataService } from '../../http/http-data.service';
import { DOCUMENT } from '@angular/common';
import * as bowser from 'bowser';

interface ILogEntry {
  logger:string;
  level:LogLevel;
  message?:string;
  properties?:{ [ key:string ]:any };
}

enum ILoggerType {
  CLIENT = 'GA2Client',
  UI = 'UI'
}

interface ILogResponse extends IRecord {
  message:string;
  logger:ILoggerType,
  logDate:number;
  userId:number;
  userName:string;
  level:LogLevel;
}

export interface ILogMetrics {
  userAgent:string;
  browser?:string;
  browserCompatMode:string;
  buildNumber?:string;
  logs?:ILogPayload[];
}

export type LogType = string | Error | HttpErrorResponse;

export interface ILogPayload {
  message:LogType;
  stack?:string;
  level:LogLevel;
  timestamp:number;
  date:Date;
  clientUrl:string;
  occurredTimes?:number;   // how many times the last error occurred
  occurredLastDate?:Date;   // the date when the last error occurred
}


export enum LogLevel {
  ERROR = 'ERROR',
  WARN = 'WARN',
  INFO = 'INFO',
  DEBUG = 'DEBUG'
}

@Injectable()
export class RemoteLoggerDataService {
  constructor(
    @Inject(Window) private window:IExtendedWindow,
    @Inject(DOCUMENT) private document:IExtendedDocument,
    private httpDataService:HttpDataService
  ) {
    /**/
  }

  public remoteLog(message:string | any, level?:LogLevel):Promise<ILogResponse | void> {
    if (!message) {
      return Promise.reject();
    }

    const data:ILogEntry = {
      level: level || LogLevel.ERROR,
      logger: ILoggerType.CLIENT,
      message: _.isString(message)? message : util.toJson(message)
    };

    return this.httpDataService.doPOST('rest/logger', undefined, data);
  }

  private logMetrics(metrics:ILogMetrics, level?:LogLevel):Promise<ILogResponse | void> {
    if (!metrics) {
      return Promise.reject();
    }

    const data:ILogEntry = {
      level: level || LogLevel.INFO,
      logger: ILoggerType.UI,
      properties: metrics
    };

    return this.httpDataService.doPOST('rest/logger', undefined, data);
  }

  public logBrowserDetails(logPayload?:ILogPayload[], level?:LogLevel):Promise<ILogResponse | void> {
    const metrics:ILogMetrics = {
      logs: logPayload,
      userAgent: this.window.navigator?.userAgent,
      browserCompatMode: this.document.documentMode,
      browser: `${bowser.name} ${bowser.version}`,
      buildNumber: 'GA2-2.0.23716-16858' // placeholder to be replaced in the static files
    };

    return this.logMetrics(metrics, level);
  }
}